import { Stack, styled } from "@mui/material";
import { CloseIcon } from "Assets/icons";
import { XsText } from "Components/Text";
import { OptionType } from "types";

const AutocompleteChips = ({
  options = [],
  onDeleteSelect,
}: {
  options?: OptionType[];
  onDeleteSelect?: (value: string | number) => void;
}) => {
  if (options?.length === 0) return null;

  return (
    <Stack direction="row" flexWrap="wrap" gap={0.5}>
      {options.map((option: OptionType, i: number) => {
        return (
          <SelectChip key={i}>
            <XsText>{option.label}</XsText>
            <CloseIcon onClick={() => onDeleteSelect?.(option.value)} />
          </SelectChip>
        );
      })}
    </Stack>
  );
};

const SelectChip = styled("div")({
  borderRadius: 8,
  padding: "4px 8px",
  border: "1px solid #E0E0E0",
  display: "flex",
  gap: 4,
  alignItems: "center",
  backgroundColor: "#fff",
  svg: {
    cursor: "pointer",
    width: 8,
    height: 8,
  },
});

export default AutocompleteChips;
